type ArticleShellProps = {
    children: React.ReactNode;
};

export function ArticleShell({ children }: ArticleShellProps) {
    return (
        <div
            className={`mx-20 mt-20 max-w-[456px] flex-col items-center`}
            style={{
                paddingBottom: 'max(20px, env(safe-area-inset-bottom))',
                paddingLeft: 'env(safe-area-inset-left)',
                paddingRight: 'env(safe-area-inset-right)',
            }}
        >
            {children}
        </div>
    );
}
